export default function (value, width, height, quality = 85, format = 'webp') {
    return value.includes('?') ? `${value}&w=${width}&h=${height}&q=${quality}&fm=${format}` : `${value}?w=${width}&h=${height}&q=${quality}&fm=${format}`;
}
